import { createSelector } from 'reselect';
import { initialState } from '../components/members_slice';
import { createActionStatusesSelector, createStatusForActionSelector, } from '../utils/action_statuses_helper';
var getMembersStore = function (state) { return state.members || initialState; };
export var getMembers = createSelector(getMembersStore, function (members) {
    if (members) {
        return members.members;
    }
    return null;
});
export var getMembersPagination = createSelector(getMembersStore, function (members) {
    if (members) {
        return members.pagination;
    }
    return null;
});
export var getActionStatuses = createActionStatusesSelector(getMembersStore, initialState);
export var getStatusForAction = createStatusForActionSelector(getActionStatuses);
